import React from 'react'

import { MatchCheckIns } from '@plvs/rally/features/match/checkIns/MatchCheckIns'
import { useParams } from 'react-router'

export const MatchCheckInsPage: React.FC = () => {
  const { matchId } = useParams<{ matchId: string }>()
  return <MatchCheckIns matchId={matchId} />
}
